import isPlainObject from 'lodash/isPlainObject';

const isObject = (obj) => obj && typeof obj === 'object';

export default function mergeDeep(target, ...sources) {
  if (!isObject(target)) {
    return null;
  }

  const lastSourcesElement = sources.length > 0 ? sources[sources.length - 1] : null;
  const hasOptionsArgument =
    isPlainObject(lastSourcesElement) &&
    ['excludeKeys', 'concatArray'].some((key) => Object.keys(lastSourcesElement).includes(key));
  const optionsArgument = hasOptionsArgument ? sources.pop() : {};
  const { excludeKeys = [], concatArray = true } = optionsArgument;

  const returnObject = { ...target };

  sources.forEach((source) => {
    if (!isObject(source)) {
      return;
    }

    for (const key of Object.keys(source)) {
      const targetValue = returnObject[key];
      const sourceValue = source[key];

      if (!excludeKeys.includes(key)) {
        if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
          returnObject[key] = concatArray === true ? targetValue.concat(sourceValue) : sourceValue;
          // eslint-disable-next-line no-continue
          continue;
        }

        if (isObject(targetValue) && isObject(sourceValue)) {
          returnObject[key] = mergeDeep({ ...targetValue }, sourceValue, optionsArgument);
          // eslint-disable-next-line no-continue
          continue;
        }
      }

      returnObject[key] = sourceValue;
    }
  });

  return returnObject;
}
